export const PAYMENT_TYPE_ORDER = ["HOURLY", "HALF_DAY", "FULL_DAY"];

export function sortByPaymentType(rates = []) {
  return [...rates].sort(
    (a, b) =>
      PAYMENT_TYPE_ORDER.indexOf(a.paymentType) -
      PAYMENT_TYPE_ORDER.indexOf(b.paymentType)
  );
}
